import {useState, useContext} from 'react';
import Section from './UI/Section';
import LabelAndInput from './UI/LabelAndInput';
import {Context} from '../context';
import Button from './UI/Button';
import {getPasswordErrors} from '../helperFunctions';
import ErrorNote from './UI/ErrorNote';

function ResetPassword() {
  const {localeText, resetPassword, setSnackBarMessage} = useContext(Context);
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [errors, setErrors] = useState([]);
  const [passwordResetComplete, setPasswordResetComplete] = useState(false);

  const submitHandler = e => {
    e.preventDefault();

    const passwordErrors = getPasswordErrors(
      password,
      passwordConfirm,
      localeText
    );
    if (passwordErrors.length > 0) {
      setErrors(passwordErrors);
      return;
    }

    const urlArray = window.location.href.split('/');
    const token = urlArray[urlArray.length - 1];

    resetPassword(token, password).then(ret => {
      if (!ret.errors) {
        setSnackBarMessage('Password Successfully Reset');
        setPasswordResetComplete(true);
      } else {
        setSnackBarMessage('Unable to reset password');
      }
    });
  };

  return (
    <Section
      sectionId='reset-password'
      heading={localeText('rw_header_reset_password', 'Reset Password')}
      className='h-full'
    >
      {!passwordResetComplete ? (
        <form action='' onSubmit={submitHandler}>
          <p>
            Please enter a new password for your account
            {/*TODO connect api email */}
          </p>
          <div className='md:w-96'>
            <LabelAndInput
              name='password'
              label={localeText('rw_title_new_password', 'New Password')}
              type='password'
              placeholder={localeText(
                'rw_title_new_password_placeholder',
                'New Password'
              )}
              className='w-full'
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
            <LabelAndInput
              name='password-confirm'
              label={localeText(
                'rw_title_new_password_confirm',
                'Confirm New Password'
              )}
              type='password'
              placeholder={localeText(
                'rw_title_new_password_confirm_placeholder',
                'Retype New Password'
              )}
              className='w-full'
              value={passwordConfirm}
              onChange={e => setPasswordConfirm(e.target.value)}
              required
            />

            {errors.map((error, index) => {
              return <ErrorNote key={index}>{error}</ErrorNote>;
            })}
            <Button
              className='w-full mt-6 bg-red hover:text-white'
              type='submit'
            >
              Reset Password
            </Button>
          </div>
        </form>
      ) : (
        <div className='w-full h-full flex justify-center items-center'>
          <p className='text-center text-2xl text-green-600'>
            Password Successfully Reset.
          </p>
        </div>
      )}
    </Section>
  );
}

export default ResetPassword;
